import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  getService,
  getListBillerService,
  updateStatus,
} from '../../redux/actions/serviceBiller';

import ServiceDetail from './ServiceDetail.page';

const mapStateToProps = state => ({
  service: state.allbiller.service,
  listBillerService: state.allbiller.listBillerService,
  loading: state.allbiller.loading,
});

const mapDispatchToProps = dispatch => ({
  getService: id => {
    dispatch(getService(id));
  },
  getListBillerService: (id, params, callback) => {
    dispatch(getListBillerService(id, params, callback));
  },
  updateStatus: (id, type, callback) => {
    dispatch(updateStatus(id, type, callback));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ServiceDetail));
